import { render, staticRenderFns } from "./politica-alcohol-drogas-editar.vue?vue&type=template&id=7e9ef030&scoped=true&"
import script from "./politica-alcohol-drogas-editar.vue?vue&type=script&lang=js&"
export * from "./politica-alcohol-drogas-editar.vue?vue&type=script&lang=js&"
import style0 from "./politica-alcohol-drogas-editar.vue?vue&type=style&index=0&id=7e9ef030&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9ef030",
  null
  
)

export default component.exports